import React from "react";
import { HiMenuAlt4 } from "react-icons/hi";

import { images } from "../../constants";
import "./Navbar.scss";

const Navbar = ({setMenuOpen}) => {
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
        <li className="app__flex p-text" key={"blog"}>
          <div />
          <a
            href="https://ahmedf.hashnode.dev"
            target="_blank"
            rel="noreferrer"
          >
            Blog
          </a>
        </li>
      </ul>
      <div className="app__navbar-burgermenu">
        <HiMenuAlt4 onClick={() => setMenuOpen(true)} />
      </div>
    </nav>
  );
};

export default Navbar;
